import React, { createContext, useContext, useState, useEffect } from 'react';

const translations = {
  fr: {
    // Navigation
    dashboard: 'Tableau de bord',
    newSimulation: 'Nouvelle Simulation',
    history: 'Historique',
    simulationHistory: 'Historique des simulations',
    admin: 'Administration',
    profile: 'Profil',
    logout: 'Déconnexion',
    
    // Auth
    login: 'Connexion',
    register: 'Inscription',
    email: 'Email',
    password: 'Mot de passe',
    name: 'Nom',
    forgotPassword: 'Mot de passe oublié ?',
    noAccount: "Pas encore de compte ?",
    hasAccount: 'Déjà un compte ?',
    signIn: 'Se connecter',
    signUp: "S'inscrire",
    
    // Dashboard
    welcome: 'Bienvenue',
    recentSimulations: 'Simulations récentes',
    viewAll: 'Voir tout',
    createNew: 'Créer une simulation',
    noSimulations: 'Aucune simulation',
    startFirst: 'Créez votre première simulation pour commencer.',
    
    // Simulation Steps
    step: 'Étape',
    of: 'sur',
    next: 'Suivant',
    back: 'Retour',
    calculate: 'Calculer',
    save: 'Enregistrer',
    
    // Step 1: General Info
    generalInfo: 'Informations Générales',
    projectName: 'Nom du projet',
    projectType: 'Type de projet',
    openingDate: 'Date d\'ouverture estimée',
    retailerName: 'Nom de l\'enseigne',
    address: 'Adresse',
    postalCode: 'Code Postal',
    city: 'Ville',
    storeSurface: 'Surface magasin (m²)',
    zoneRM: 'RM de la zone',
    zoneAvgAge: 'Âge moyen de la zone',
    zoneCSP: 'CSP Majoritaire',
    
    // Step 2: Competition
    competitionInfo: 'Information Concurrence',
    hasCompetitor: 'Concurrence présente ?',
    competitorName: 'Nom du concurrent',
    engagementDuration: 'Durée de l\'engagement (mois)',
    currentDiscount: 'Remise actuelle (%)',
    currentConcept: 'Concept mis en place',
    engagementEndDate: 'Date de fin d\'engagement',
    exitReasons: 'Raisons de sortie',
    competitorCA: 'CA Annuel concurrent',
    hasOtherRestaurant: 'Autre restaurant dans le magasin ?',
    hasPanAsian: 'Restaurant pan-asiatique présent ?',
    
    // Step 3: Financial Data
    financialData: 'Données Financières',
    annualCAHorsCarburant: 'CA Annuel hors Carburant',
    annualCAAlimentaire: 'CA Annuel Alimentaire',
    annualCAPoissonnerie: 'CA Annuel Poissonnerie + Saurisserie',
    annualFrequentation: 'Fréquentation annuelle (passages caisse)',
    globalTicketMoyen: 'Ticket moyen Global',
    
    // Step 4: CAPEX
    capexInvestment: 'Investissement CAPEX',
    investor: 'Investisseur',
    cornerInvestor: 'Corner',
    vitrineInvestor: 'Vitrine',
    inoxInvestor: 'Inox',
    concept: 'Concept',
    coolingCell: 'Cellule de refroidissement',
    wok: 'Wok',
    capexCorner: 'CAPEX Corner (€)',
    capexVitrine: 'CAPEX Vitrine (€)',
    capexInox: 'CAPEX Inox (€)',
    capexComputer: 'Informatique & Caisse (€)',
    capexLocalLegal: 'Frais locaux & légaux (€)',
    capexRobots: 'Robots (€)',
    
    // Step 5: Hypothesis Parameters
    hypothesisParams: 'Paramètres des Hypothèses',
    dealTemperature: 'Température du dossier',
    sushiCaptation: 'Taux de captation Sushi (%)',
    wokCaptation: 'Taux de captation Wok (%)',
    sushiBasket: 'Panier moyen Sushi (€)',
    wokBasket: 'Panier moyen Wok (€)',
    alimentaireCaptation: 'Quota alimentaire (%)',
    poissonnerieCaptation: 'Quota poissonnerie (%)',
    
    // Step 6: Photos
    photos: 'Photos',
    
    // Step 7: Contract
    contractInfo: 'Informations Contrat',
    commissionModel: 'Modèle de commission',
    flatCommission: 'Commission fixe',
    variableCommission: 'Commission variable',
    flatRate: 'Taux fixe (%)',
    negotiatedRate: 'Taux négocié (%)',
    contractDuration: 'Durée du contrat (mois)',
    tvaRate: 'TVA (%)',
    
    // Results
    results: 'Résultats',
    hypothesis: 'Hypothèse',
    hypothesis1: 'Hypothèse 1 - Fréquentation',
    hypothesis2: 'Hypothèse 2 - CA Alimentaire',
    hypothesis3: 'Hypothèse 3 - Poissonnerie',
    caTTCMonthly: 'CA TTC Mensuel',
    caTTCAnnual: 'CA TTC Annuel',
    caHTAnnual: 'CA HT Annuel',
    commissionRate: 'Taux de commission',
    totalCommission: 'Commission totale HT',
    clientInvestment: 'Investissement client',
    netMargin: 'Marge nette Année N',
    status: 'Statut',
    viable: 'Viable',
    risky: 'Risqué',
    nonViable: 'Non viable',
    recommended: 'Recommandé',
    
    // P&L
    plProjections: 'Projections P&L',
    year: 'Année',
    grossSalesTTC: 'CA Brut TTC',
    grossSalesHT: 'CA Brut HT',
    salesCommissions: 'Commissions',
    foodCosts: 'Coûts matières',
    directLaborCosts: 'Coûts main-d\'œuvre',
    otherCosts: 'Autres coûts',
    contributionMargin: 'Marge de contribution',
    sga: 'SGA',
    ebitda: 'EBITDA',
    
    // Summary
    summary: 'Récapitulatif',
    totalCapex: 'CAPEX Total',
    paybackPeriod: 'Délai de retour',
    months: 'mois',
    years: 'années',
    caPotential: 'CA Potentiel HT',
    recommendedHypothesis: 'Hypothèse recommandée',
    
    // Admin
    adminDashboard: 'Dashboard Admin',
    totalSimulations: 'Total simulations',
    totalUsers: 'Total utilisateurs',
    avgCapex: 'CAPEX moyen',
    avgPayback: 'Payback moyen',
    avgCA: 'CA moyen',
    users: 'Utilisateurs',
    role: 'Rôle',
    createdAt: 'Créé le',
    
    // Actions
    export: 'Exporter',
    exportPDF: 'Exporter PDF',
    exportExcel: 'Exporter Excel',
    delete: 'Supprimer',
    edit: 'Modifier',
    view: 'Voir',
    compare: 'Comparer',
    
    // Misc
    loading: 'Chargement...',
    error: 'Erreur',
    success: 'Succès',
    required: 'Requis',
    optional: 'Optionnel',
    yes: 'Oui',
    no: 'Non',
    ccd: 'CCD',
    client: 'Client',
  },
  en: {
    // Navigation
    dashboard: 'Dashboard',
    newSimulation: 'New Simulation',
    history: 'History',
    simulationHistory: 'Simulation history',
    admin: 'Administration',
    profile: 'Profile',
    logout: 'Logout',
    
    // Auth
    login: 'Login',
    register: 'Register',
    email: 'Email',
    password: 'Password',
    name: 'Name',
    forgotPassword: 'Forgot password?',
    noAccount: "Don't have an account?",
    hasAccount: 'Already have an account?',
    signIn: 'Sign in',
    signUp: 'Sign up',
    
    // Dashboard
    welcome: 'Welcome',
    recentSimulations: 'Recent Simulations',
    viewAll: 'View all',
    createNew: 'Create simulation',
    noSimulations: 'No simulations',
    startFirst: 'Create your first simulation to get started.',
    
    // Simulation Steps
    step: 'Step',
    of: 'of',
    next: 'Next',
    back: 'Back',
    calculate: 'Calculate',
    save: 'Save',
    
    // Step 1: General Info
    generalInfo: 'General Information',
    projectName: 'Project Name',
    projectType: 'Project Type',
    openingDate: 'Estimated Opening Date',
    retailerName: 'Retailer Name',
    address: 'Address',
    postalCode: 'Postal Code',
    city: 'City',
    storeSurface: 'Store Surface (m²)',
    zoneRM: 'Zone RM',
    zoneAvgAge: 'Zone Average Age',
    zoneCSP: 'Main CSP',
    
    // Step 2: Competition
    competitionInfo: 'Competition Information',
    hasCompetitor: 'Competition present?',
    competitorName: 'Competitor Name',
    engagementDuration: 'Engagement Duration (months)',
    currentDiscount: 'Current Discount (%)',
    currentConcept: 'Current Concept',
    engagementEndDate: 'Engagement End Date',
    exitReasons: 'Exit Reasons',
    competitorCA: 'Competitor Annual CA',
    hasOtherRestaurant: 'Other restaurant in store?',
    hasPanAsian: 'Pan-asian restaurant present?',
    
    // Step 3: Financial Data
    financialData: 'Financial Data',
    annualCAHorsCarburant: 'Annual CA excl. Fuel',
    annualCAAlimentaire: 'Annual Food CA',
    annualCAPoissonnerie: 'Annual Fish + Deli CA',
    annualFrequentation: 'Annual Traffic (transactions)',
    globalTicketMoyen: 'Average Ticket',
    
    // Step 4: CAPEX
    capexInvestment: 'CAPEX Investment',
    investor: 'Investor',
    cornerInvestor: 'Corner',
    vitrineInvestor: 'Showcase',
    inoxInvestor: 'Stainless Steel',
    concept: 'Concept',
    coolingCell: 'Cooling Cell',
    wok: 'Wok',
    capexCorner: 'CAPEX Corner (€)',
    capexVitrine: 'CAPEX Showcase (€)',
    capexInox: 'CAPEX Inox (€)',
    capexComputer: 'IT & Cash Register (€)',
    capexLocalLegal: 'Local & Legal Fees (€)',
    capexRobots: 'Robots (€)',
    
    // Step 5: Hypothesis Parameters
    hypothesisParams: 'Hypothesis Parameters',
    dealTemperature: 'Deal temperature',
    sushiCaptation: 'Sushi Capture Rate (%)',
    wokCaptation: 'Wok Capture Rate (%)',
    sushiBasket: 'Sushi Average Basket (€)',
    wokBasket: 'Wok Average Basket (€)',
    alimentaireCaptation: 'Food Capture Rate (%)',
    poissonnerieCaptation: 'Fish Capture Rate (%)',
    
    // Step 6: Photos
    photos: 'Photos',
    
    // Step 7: Contract
    contractInfo: 'Contract Information',
    commissionModel: 'Commission Model',
    flatCommission: 'Flat Commission',
    variableCommission: 'Variable Commission',
    flatRate: 'Flat Rate (%)',
    negotiatedRate: 'Negotiated Rate (%)',
    contractDuration: 'Contract Duration (months)',
    tvaRate: 'VAT (%)',
    
    // Results
    results: 'Results',
    hypothesis: 'Hypothesis',
    hypothesis1: 'Hypothesis 1 - Traffic',
    hypothesis2: 'Hypothesis 2 - Food CA',
    hypothesis3: 'Hypothesis 3 - Fish',
    caTTCMonthly: 'Monthly CA (incl. VAT)',
    caTTCAnnual: 'Annual CA (incl. VAT)',
    caHTAnnual: 'Annual CA (excl. VAT)',
    commissionRate: 'Commission Rate',
    totalCommission: 'Total Commission (excl. VAT)',
    clientInvestment: 'Client Investment',
    netMargin: 'Net Margin Year N',
    status: 'Status',
    viable: 'Viable',
    risky: 'Risky',
    nonViable: 'Non-viable',
    recommended: 'Recommended',
    
    // P&L
    plProjections: 'P&L Projections',
    year: 'Year',
    grossSalesTTC: 'Gross Sales (incl. VAT)',
    grossSalesHT: 'Gross Sales (excl. VAT)',
    salesCommissions: 'Commissions',
    foodCosts: 'Food Costs',
    directLaborCosts: 'Direct Labor Costs',
    otherCosts: 'Other Costs',
    contributionMargin: 'Contribution Margin',
    sga: 'SGA',
    ebitda: 'EBITDA',
    
    // Summary
    summary: 'Summary',
    totalCapex: 'Total CAPEX',
    paybackPeriod: 'Payback Period',
    months: 'months',
    years: 'years',
    caPotential: 'CA Potential (excl. VAT)',
    recommendedHypothesis: 'Recommended Hypothesis',
    
    // Admin
    adminDashboard: 'Admin Dashboard',
    totalSimulations: 'Total Simulations',
    totalUsers: 'Total Users',
    avgCapex: 'Average CAPEX',
    avgPayback: 'Average Payback',
    avgCA: 'Average CA',
    users: 'Users',
    role: 'Role',
    createdAt: 'Created at',
    
    // Actions
    export: 'Export',
    exportPDF: 'Export PDF',
    exportExcel: 'Export Excel',
    delete: 'Delete',
    edit: 'Edit',
    view: 'View',
    compare: 'Compare',
    
    // Misc
    loading: 'Loading...',
    error: 'Error',
    success: 'Success',
    required: 'Required',
    optional: 'Optional',
    yes: 'Yes',
    no: 'No',
    ccd: 'CCD',
    client: 'Client',
  },
};

const LanguageContext = createContext(null);

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const [language, setLanguage] = useState(() => {
    const saved = localStorage.getItem('capex_language');
    return saved || 'fr';
  });

  useEffect(() => {
    localStorage.setItem('capex_language', language);
    document.documentElement.lang = language;
  }, [language]);

  const t = (key) => {
    return translations[language][key] || key;
  };

  const toggleLanguage = () => {
    setLanguage((prev) => (prev === 'fr' ? 'en' : 'fr'));
  };

  const value = {
    language,
    setLanguage,
    toggleLanguage,
    t,
    isFrench: language === 'fr',
  };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
};
